import React from 'react';
import { Flex } from "antd";
import { Link } from "react-router-dom";
import classes from "../../components/Header/header.module.css";
import IntlMessage from "../../../components/IntlMessage/IntlMessage";
import { clrs } from "../../../constants/colors";

const Header = () => {
    return (
        <Flex className={classes.main} style={{position: "relative"}} align={"center"} justify={"center"}>
            <div style={{
                position: "absolute",
                bottom: 0,
                width: "100%",
                height: 90,
                backgroundColor: clrs.whiter
            }}></div>
            <Flex className={classes.inner_main} align={"center"} justify={"flex-start"} gap={75}>
                <Link to={'/'} className={classes.hover_text2}
                      style={{color: "black", fontSize: "1rem", fontWeight: 700}}>
                    <IntlMessage id={'homePage.main'}/>
                </Link>
                <Link to={'/monitoring'} className={classes.hover_text2}
                      style={{color: "black", fontSize: "1rem", fontWeight: 700}}>
                    <IntlMessage id={'homePage.monitoring'}/>
                </Link>
                <Link to={'/about'} className={classes.hover_text2}
                      style={{color: "black", fontSize: "1rem", fontWeight: 700}}>
                    <IntlMessage id={'homePage.aboutProject'}/>
                </Link>
                <Link to={'/dashboard'} className={classes.hover_text2}
                      style={{color: "black", fontSize: "1rem", fontWeight: 700}}>
                    <IntlMessage id={'homePage.dashboard'}/>
                </Link>
            </Flex>
        </Flex>
    );
};

export default Header;